import { z } from "zod";

/**
 * Schema for creating a new link
 */
export const createLinkSchema = z.object({
  url: z
    .string()
    .min(1, "URL을 입력해주세요")
    .url("올바른 URL 형식이 아닙니다"),
  title: z.string().optional(),
  tags: z.array(z.string()).optional(),
});

export type CreateLinkInput = z.infer<typeof createLinkSchema>;

/**
 * Schema for updating an existing link
 */
export const updateLinkSchema = z.object({
  url: z
    .string()
    .min(1, "URL을 입력해주세요")
    .url("올바른 URL 형식이 아닙니다"),
  title: z.string().min(1, "제목을 입력해주세요"),
  tags: z.array(z.string()).optional(),
});

export type UpdateLinkInput = z.infer<typeof updateLinkSchema>;
